import "./PreAccessInventoryTab.css";

import { Column, CursorDataGrid, Row, StackedBarChart } from "../../../../../../../widget";
import { InventoryChartKey } from "../InventoryChartKey";
import { PRE_ACCESS_TOTAL_COLUMN_NAMES } from "./constants/preAccessInventoryTab.constants";
import { PreAccessInventoryTabProps } from "./models/preAccessInventoryTab.models";
import { usePreAccessInventoryTab } from "./usePreAccessInventoryTab";

export const PreAccessInventoryTab = ({ projectUuid, unitMeasurement }: PreAccessInventoryTabProps): JSX.Element => {
  const {
    columns,
    defaultSortingCriteria,
    hasData,
    hasEnoughIssuancesForScrolling,
    isLoading,
    onChange,
    stackedChartData,
    xAxisLabels,
    showAvailable,
  } = usePreAccessInventoryTab({
    projectUuid,
    unitMeasurement,
  });
  return (
    <div className="ProjectTabSection PreAccessInventoryTab">
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Inventory</h2>
        </Column>
      </Row>
      {stackedChartData && xAxisLabels && hasData && (
        <Row spacingV="2xl">
          <Column span={12}>
            <StackedBarChart
              xLabels={xAxisLabels}
              data={stackedChartData}
              hasYAxisGridLines
              hasYAxisTicks
              showLegend={false}
            />
            <InventoryChartKey unitMeasurement={unitMeasurement} showAvailable={showAvailable} />
          </Column>
        </Row>
      )}
      <Row spacingV={hasEnoughIssuancesForScrolling ? "ml" : undefined}>
        <Column span={12}>
          <div className={`ProjectInventoryDataGrid ${hasEnoughIssuancesForScrolling ? "Scrollable" : ""}`}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              showFilterToggle
              sortable
              onChange={onChange}
              data={[]}
              dataIsLoading={isLoading}
              noDataMessage="No inventory to display"
              pagination={{ pageSize: 1000 }}
              hasTotalRow
              totalColumnNames={PRE_ACCESS_TOTAL_COLUMN_NAMES}
              defaultSortingCriteria={defaultSortingCriteria}
              infiniteScroll
              variant="seed"
            />
          </div>
        </Column>
      </Row>
    </div>
  );
};
